import React from 'react'

function Icon({ children, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {children}
    </svg>
  )
}

export function CloseIcon() {
  return (
    <Icon>
      <path d="M5.2 5.2l13.6 13.6M18.8 5.2 5.2 18.8" />
    </Icon>
  )
}

export function GridIcon() {
  return (
    <Icon>
      <rect x="3.2" y="3.2" width="17.6" height="17.6" rx="2.4" />
      <path d="M9.07 3.2v17.6M14.93 3.2v17.6M3.2 9.07h17.6M3.2 14.93h17.6" />
    </Icon>
  )
}

export function TimerIcon() {
  return (
    <Icon>
      <circle cx="12" cy="13.1" r="7.05" />
      <path d="M12 13.1V9.15" />
      <path d="M12 13.1 15.15 15.2" />
      <path d="M9.15 3.15h5.7" />
    </Icon>
  )
}

export function TorchIcon() {
  return (
    <Icon>
      <path d="M8 2h8l-1 5H9L8 2z" />
      <path d="M9 7h6v6l-2 7h-2l-2-7V7z" />
    </Icon>
  )
}

export function FlipIcon() {
  return (
    <Icon>
      <path d="M3 9a9 9 0 0115.5-5.5L20 5" />
      <path d="M21 3v5h-5" />
      <path d="M21 15a9 9 0 01-15.5 5.5L4 19" />
      <path d="M3 21v-5h5" />
    </Icon>
  )
}

export function PhotoIcon() {
  return (
    <Icon>
      <path d="M8 7.2 9.3 5.5h5.4L16 7.2h2.1A1.7 1.7 0 0 1 19.8 8.9v7.8a1.7 1.7 0 0 1-1.7 1.7H5.9A1.7 1.7 0 0 1 4.2 16.7V8.9A1.7 1.7 0 0 1 5.9 7.2H8z" />
      <circle cx="12" cy="12.8" r="3.05" />
    </Icon>
  )
}

export function VideoIcon() {
  return (
    <Icon fill="currentColor" stroke="none">
      <rect x="2" y="6.7" width="13.1" height="10.6" rx="1.9" />
      <path d="M14.3 9.85 21.6 6.35v11.3L14.3 14.15z" />
    </Icon>
  )
}
